var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "qmwmitdo3c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71ECDA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B8C0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "dyeq4z9xzb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98F3E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66D0D5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "kicr5iz2ta"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#kicr5iz2ta)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,5 C35.3506307,5 41.0997889,7.58913593 45.2614593,11.7744092 C49.4251707,15.9617352 52,21.7466044 52,28.1361163 C52,33.6616494 48.5782888,40.4412816 44.3475291,46.410863 C38.7842583,54.2606113 31.7296255,61 29,61 C26.2703745,61 19.2157417,54.2606113 13.6524709,46.410863 C9.42171119,40.4412816 6,33.6616494 6,28.1361163 C6,21.7466044 8.57482926,15.9617352 12.7385407,11.7744092 C16.9002111,7.58913593 22.6493693,5 29,5 Z",
    stroke: "url(#dyeq4z9xzb)",
    strokeWidth: 2,
    fill: "url(#qmwmitdo3c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,15.991596 C6.80872607,12.6501041 13.3219791,14.5624447 19.9636987,16.8354758 C19.0323164,19.1017014 18.1330507,21.4019545 17.0988951,23.6409582 C16.7414006,24.1487963 16.1868641,24.4588114 15.5894134,24.484838 C12.4741,24.5528928 9.35878668,24.5596983 6.24347334,24.484838 C5.69560417,24.4799722 5.17254753,24.242118 4.79180155,23.8247062 C3.11531334,21.1909845 1.53517503,18.5096245 0,15.991596 L0,15.991596 Z M4.55413847,4.08880726 C7.65660516,2.65965595 10.5663721,1.27133754 13.5467955,0.005517814 C14.1062285,-0.0415303472 14.6501276,0.214584479 14.992044,0.686066054 C16.585029,5.10962962 18.1266273,9.58083155 19.7838456,14.426335 C16.1803594,13.4871785 12.9108862,12.6501041 9.67352968,11.7721969 C9.37131988,11.6041785 9.12645008,11.3399798 8.97338709,11.0167883 C7.56025527,8.7913956 6.12785346,6.56600285 4.55413847,4.08880726 Z M0,13.4599565 L3.21166324,5.97392588 L7.10419909,11.9763614 L0,13.4599565 Z",
    transform: "translate(19.018151 14.437179)",
    fill: "#F7FFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/mk.98f18a611424dcfb36c3c8784668ace6.svg";
export { ForwardRef as ReactComponent };